module.exports = __webpack_public_path__ + "static/media/back-white.d93039ed.svg";